import React, {useState} from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";


const SignupNewUser = () => {
    const[isRequired, setIsRequired] = useState(true);
    const [role, setRole] = useState('');
    const[userName, setUsername] = useState('');
    const[dob, setDob] = useState('');
    const[location, setLocation] = useState('')


    const handleUsernameChange = (event) => {
        setUsername(event.target.value)
    }
    const handleDobChange = (event) => {
        setDob(event.target.value)
    }
    const handleLocationChange = (event) => {
        setLocation(event.target.value)
    }
    const saveInfo = (event) => {
        firebase.firestore()
        .collection('users')
        .doc(firebase.auth().currentUser.uid)
        .update({
            username: userName,
            dob: dob,
            location: location,
            role: role
        })
        .then(() => {
            //console.log('Updated successful')
            window.location = '/'
        }).catch((error) => {
            console.log(error)
        })
    event.preventDefault();
}
const handleRoleChange = (event) => {
    setRole(event.target.value);
};
  return (
    <div>
        <div className='settings-body'>
            <Container>
                <Row>
                    <Col lg={4} md={4} sm={0} xs={0}>
                        <div className='settings-side-tab'>
                            <button className='account-action-button'>Account</button>
                        </div>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12}>
                        <div className='settings-info-tab'>
                            <h4>Account</h4>
                            <form onSubmit={saveInfo}>
                                <Row className='settings-action-row'>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <p><label htmlFor='username'>Username:{isRequired && <span className='required-asterisk'>*</span>}</label></p>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <input name='username' id='username' placeholder='Username' value={userName} onChange={handleUsernameChange} required></input>
                                    </Col>
                                </Row>

                                <Row className='settings-action-row'>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <p><label htmlFor='location'>Location:{isRequired && <span className='required-asterisk'>*</span>}</label></p>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <input name='location' id='location' placeholder='Location' value={location} onChange={handleLocationChange} required></input>
                                    </Col>
                                </Row>

                                <Row className='settings-action-row'>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <p><label htmlFor='location'>Role:{isRequired && <span className='required-asterisk'>*</span>}</label></p>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <select name='role' id='role' className='waitlist-modal-input' value={role} onChange={handleRoleChange} required>
                                            <option value="">Select an item...</option>
                                            <option value='foodie'>I'm a foodie</option>
                                            <option value='chef'>I'm a chef</option>
                                            <option value='restaurant'>I'm a restaurant</option>
                                            <option value='food-blogger'>I'm a food blogger</option>
                                            <option value='food-content-creator'>I'm a food content creator</option>
                                            <option value='food-items-vendor'>I'm a food items vendor</option>
                                        </select>
                                    </Col>
                                </Row>

                                <Row className='settings-action-row'>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <p><label htmlFor='dob'>D.O.B:{isRequired && <span className='required-asterisk'>*</span>}</label></p>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <input name='dob' id='dob' type='date' value={dob} onChange={handleDobChange} required></input>
                                        <p className='settings-more-info-texts'>Some content's visibility might be subject to age restriction. We will not share your Birthday with other users. Read more in <a href='#' className='settings-read-more-link'>Terms of Service</a></p>
                                    </Col>
                                </Row>

                                <button type='submit' name='submit' value='submit' className='account-settings-save-button'>Save</button>
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </div>
  )
}

export default SignupNewUser